export const LOCALIZATION_REQUEST = 'LOCALIZATION_REQUEST';
export const LOCALIZATION_SUCCESS = 'LOCALIZATION_SUCCESS';

export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_LOGOUT_IF_APPLICABLE = 'AUTH_LOGOUT_IF_APPLICABLE';
export const AUTH_USER = 'AUTH_USER';
export const AUTH_AUTOLOGIN = 'AUTH_AUTOLOGIN';
export const SET_RESET_PASSWORD = <const>'setPasswordReset';
export const SET_CHANGE_PASSWORD = <const>'changePassword';
export const LOGGED_USER = 'LOGGED_USER';
export const INITIALISE_STORE = 'INITIALISE_STORE';
export const USER_ACTIVE_NEW_SESSION = 'USER_ACTIVE_NEW_SESSION';

export const SAVE_STATE = 'SAVE_STATE';
export const LOAD_STATE = 'LOAD_STATE';

export const RESET = 'RESET';
export const ERROR = 'ERROR';

export const SAVE_PROPS = 'SAVE_PROPS';
export const REFRESH_PREVIOUS = 'REFRESH_PREVIOUS';
export const PAGE_MGR_BACK_TO = 'PAGE_MGR_BACK_TO';
export const PAGE_MGR_LOAD = 'PAGE_MGR_LOAD';
export const PGE_MGR_REMOVE_PAGES = 'PGE_MGR_REMOVE_PAGES';
export const PGE_MGR_EDIT_PAGE = 'PGE_MGR_EDIT_PAGE';
export const PAGE_MGR_CLEAR = 'PAGE_MGR_CLEAR';
export const PAGE_MGR_MAPPER = 'PAGE_MGR_MAPPER';
export const PAGE_MGR_MAPPER_DATA = 'PAGE_MGR_MAPPER_DATA';
export const PAGE_MGR_CLEAR_MAPPER = 'PAGE_MGR_CLEAR_MAPPER';
export const PAGE_MGR_REMOVE_TO = 'PAGE_MGR_REMOVE_TO';
export const PAGE_MGR_SET = 'PAGE_MGR_SET';

/**
 * Single sign on
 */
export const SSO_CHECK = 'SSO_CHECK';
export const SSO_STATE_UPDATE = 'SSO_STATE_UPDATE';
export const SSO_SIGNOUT = 'SSO_SIGNOUT';
export const SSO_AUTH_USER = 'SSO_AUTH_USER';
export const SSO_URL='SSO_URL';